import React from "react";

import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
import { Button } from "components";
import Modal from "components/UI/Modal/Modal";

import styles from "styles/pages/ModalActions.module.scss";

const FIELDS = [
    { orden: 1, campo: "tipoDeDocumentoCod", formato: "string(10)", ejemplo: "DNI", descripcion: "Tipo de documento" },
    { orden: 2, campo: "usuarioNroDeDocumentoX", formato: "string(30)", ejemplo: "12345678", descripcion: "Número de documento" },
    { orden: 3, campo: "usuarioSexo", formato: "string(1)", ejemplo: "M", descripcion: "Sexo (F, M, X)" },
    { orden: 4, campo: "usuarioFechaDeNacimiento", formato: "date(YYYY-MM-DD)", ejemplo: "1990-01-01", descripcion: "Fecha de nacimiento" },
    { orden: 5, campo: "usuarioApellidos", formato: "string(75)", ejemplo: "Pérez", descripcion: "Apellidos" },
    { orden: 6, campo: "usuarioNombres", formato: "string(50)", ejemplo: "Juan", descripcion: "Nombres" },
    { orden: 7, campo: "numeroDesde", formato: "int", ejemplo: "10", descripcion: "Número desde" },
    { orden: 8, campo: "numeroHasta", formato: "int", ejemplo: "14", descripcion: "Número hasta" },
    { orden: 9, campo: "cantidad", formato: "int", ejemplo: "5", descripcion: "Cantidad de Vouchers" },
    { orden: 10, campo: "SFVoucherFechaDesde", formato: "date(YYYY-MM-DD)", ejemplo: "2026-01-01", descripcion: "Fecha de inicio" },
    { orden: 11, campo: "SFVoucherFechaHasta", formato: "date(YYYY-MM-DD)", ejemplo: "2026-12-31", descripcion: "Fecha de fin" },

];

const downloadTemplate = () => {
    const headers = FIELDS.map((f) => `"${f.campo}"`).join(",");
    const example = FIELDS.map((f) => `"${f.ejemplo}"`).join(",");
    const content = `${headers}\n${example}\n`;

    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "PlantillaVouchers.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export default function CSVFieldsInfoModal({ open, onClose }) {
    return (
        <Modal open={open} title="Detalle de campos del CSV" onClose={onClose}>
            <div className={styles.inputs}>
                <table className={styles["fields-table"]}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Campo</th>
                            <th>Formato</th>
                            <th>Ejemplo</th>
                            <th>Descripción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {FIELDS.map((f) => (
                            <tr key={f.campo}>
                                <td>{f.orden}</td>
                                <td><code>{f.campo}</code></td>
                                <td>{f.formato}</td>
                                <td>{f.formato === 'int' ? f.ejemplo : `"${f.ejemplo}"`}</td>
                                <td>{f.descripcion}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className={styles["actions-row"]} style={{ marginTop: "1rem" }}>
                    <Button className={styles.defaultBtn} onClick={downloadTemplate}>
                        <FileDownloadOutlined fontSize="small" style={{ marginRight: "0.4rem" }} />
                        Ejemplo CSV
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
